import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export const redirect = (path: string, state = {}): void =>
  history.push(path, state);

export default history;
